<template>
  <ButtonSocial :type="'google'" @click="toLoginWithGoogle"/>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { PROJECT_KEYS } from '@shared/constants/keys/keys';
  //---------------------------
  import ButtonSocial from '@shared/UI/Buttons/ButtonSocial/ButtonSocial';
  //---------------------------
  const store = useStore();
  //---------------------------
  const CALLBACK_URL = `${store.getters.getFrontendUrl}/google/login/callback/`;
  //----------------------------
  // Редирект на Google OAuth2
  const toLoginWithGoogle = () => {
    window.location.replace(
      `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${CALLBACK_URL}&prompt=consent&response_type=code&client_id=${PROJECT_KEYS.GOOGLE_CLIENT_ID}&scope=openid%20email%20profile&access_type=offline`
    );
  };
</script>
